import { render } from "./HeroiconsSolidZoomIn.vue?vue&type=template&id=394bb42a"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidZoomIn.vue"]])

export default __exports__